import type { SummaryByExam } from '@/features/summary/api';
import { formatBRL } from '@/lib/utils';

interface Props {
  items: SummaryByExam[];
}

export function ByExamTable({ items }: Props) {
  return (
    <section className="rounded-xl border border-(--color-border) bg-(--color-surface) p-5">
      <h2 className="mb-4 font-display text-lg font-semibold">
        Por exame / procedimento
      </h2>
      {items.length === 0 ? (
        <p className="text-sm text-(--color-fg-muted)">
          Nenhum procedimento registrado no mês.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="text-left text-(--color-fg-muted)">
                <th className="py-2 pr-2 font-medium">Nome</th>
                <th className="py-2 pr-2 text-right font-medium">Qtd</th>
                <th className="py-2 pr-2 text-right font-medium">Valor unit.</th>
                <th className="py-2 text-right font-medium">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr
                  key={i.examTypeId}
                  className="border-t border-(--color-border)"
                >
                  <td className="py-2 pr-2">
                    <span className="font-medium">{i.shortName}</span>
                    <span className="ml-2 text-(--color-fg-muted)">
                      {i.name}
                    </span>
                  </td>
                  <td className="py-2 pr-2 text-right tabular-nums">{i.qty}</td>
                  <td className="py-2 pr-2 text-right tabular-nums">
                    {formatBRL(i.unitValue)}
                  </td>
                  <td className="py-2 text-right tabular-nums">
                    {formatBRL(i.subtotal)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
